import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { MY_PRIVILEGES } from '../graphql/privileges';

/**
 * Reads the privileges granted to the current user via their role and
 * exposes a `hasPrivilege(key)` helper for UI gating. Cached by Apollo so
 * subsequent reads across the app are free.
 */
export const useMyPrivileges = () => {
  const { user } = useAuth();
  const { data, loading, error, refetch } = useQuery(MY_PRIVILEGES, {
    skip: !user,
    fetchPolicy: 'cache-first',
  });
  const granted = useMemo(() => {
    const list = data?.myPrivileges;
    return Array.isArray(list) ? new Set(list) : new Set();
  }, [data]);
  const hasPrivilege = (key) => granted.has(key);
  return { granted, hasPrivilege, loading, error, refetch };
};

export default useMyPrivileges;
